document.addEventListener('turbolinks:load', function () {
    if ($('.health_inspection_reports.new, .health_inspection_reports.create, .health_inspection_reports.edit, .health_inspection_reports.update').length === 0) {
        return false
    }

    addOnClick();
    addTimeValidationListeners();
    toggleScoreBox(document.getElementById('v-health-reports-tab').querySelector('.active').dataset.target);

    function addOnClick() {
        $('.previous-step-btn').on('click', function (e) {
            e.preventDefault();

            let targetId = $(this).data("target")
            toggleScoreBox(targetId);
            submitForm(targetId, 'previous_step')
        });

        $('.next-step-btn').on('click', function (e) {
            e.preventDefault();

            let targetId = $(this).data("target")
            if(!formIsValid()) return;
            toggleScoreBox(targetId);
            submitForm(targetId, 'next_step')
        });

        $('.save-btn').on('click', function (e) {
            e.preventDefault();

            let targetId = $(this).data("target")
            if(!formIsValid()) return;
            submitForm(targetId, 'save')
        })

        $('.preview-btn').on('click', function (e) {
            e.preventDefault();

            let targetId = $(this).data("target")
            if(!formIsValid()) return;
            submitForm(targetId, 'preview')
        })

        $('#v-health-reports-tab .form-tab').on('click', function (e) {
            e.preventDefault();

            let targetId = $(this).data("target")
            // submitForm(targetId, 'switch_tab')
            changeTab(targetId);
            toggleScoreBox(targetId);
        });
    }

    function submitForm(targetId, requestType) {
        assignFormValue(targetId, requestType)
        submitReportForm()
    }

    function toggleScoreBox(targetId) {
        const scoreBox = document.getElementById('health-inspection-scores');
        const targetTab = document.querySelector(`div[data-target=${targetId}]`)
        if(['immediate', 'corrective1', 'corrective2'].includes(targetId) && targetTab.classList.contains('active')) {
            scoreBox.classList.remove('d-none');
        } else {
            scoreBox.classList.add('d-none');
        }
    }

    function changeTab(targetTabId) {
        updateTabValidations(targetTabId, 'overview');
        updateInspectionResponseValidations(targetTabId);
        updateTabValidations(targetTabId, 'signature');
    }

    function assignFormValue(nextTab, request_type) {
        $('#next_tab').val(nextTab);
        $('#request_type').val(request_type);
    }

    function submitReportForm() {
        let form = document.querySelector('#health-report-form');

        // Add submit event listener to show loader only when form is actually submitted
        form.addEventListener('submit', function() {
            showLoader();
        });

        let button = document.createElement('input');
        button.style.display = 'none';
        button.type = 'submit';
        form.appendChild(button).click();
        form.removeChild(button);
    }

    function showLoader() {
        $('.loading-spinner').show();
        $('body').css({ pointerEvents: "none" });
    }

    function inspectionResponseValidation(tabContentId, enable = true) {
        const tabContentDom = document.getElementById(tabContentId);
        outValueRadioBtns = tabContentDom.querySelectorAll('input[type=radio][value=out]');

        if(outValueRadioBtns.length === 0) return;

        if(enable) {
            outValueRadioBtns.forEach(radio => {
                radio.setAttribute('required', true);
            });
        } else {
            outValueRadioBtns.forEach(radio => {
                radio.removeAttribute('required');
            });
        }
    }

    // required because tabs can be freely switched
    // going to the last tab and trying to save
    // should trigger validate
    // focus the first required field
    function formIsValid() {
        if (!checkInputValidations()) return false;
        if (!checkRadioGroup()) return false;
        if (!checkTimeValidation()) return false;

        return true;
      }

    function checkTimeValidation() {
        const timeIn = document.querySelector('input[name="health_inspection_report[time_in]"]');
        const timeOut = document.querySelector('input[name="health_inspection_report[time_out]"]');

        if (!timeIn || !timeOut || !timeIn.value || !timeOut.value) return true;

        clearTimeError(timeOut);

        if (timeToMinutes(timeOut.value) <= timeToMinutes(timeIn.value)) {
            showTimeError(timeOut, 'Time Out must be greater than Time In');

            const tab = timeOut.closest('[data-tab-id]');
            const tabId = tab?.dataset.tabId;
            const currentTab = document.getElementById('v-health-reports-tab').querySelector('.active');
            if (tabId && tabId !== currentTab.id) {
                document.getElementById(tabId).click();
            }

            timeOut.focus();
            return false;
        }

        return true;
    }

    function timeToMinutes(timeStr) {
        const [hours, minutes] = timeStr.split(':').map(Number);
        return hours * 60 + minutes;
    }

    function showTimeError(input, message) {
        input.classList.add('is-invalid');
        const error = document.createElement('div');
        error.className = 'time-error-msg text-danger small mt-1';
        error.textContent = message;
        input.insertAdjacentElement('afterend', error);
    }

    function addTimeValidationListeners() {
        const timeOut = document.querySelector('input[name="health_inspection_report[time_out]"]');
        if (timeOut) {
            timeOut.addEventListener('change', function () { clearTimeError(timeOut); });
        }
    }

    function clearTimeError(input) {
        input.classList.remove('is-invalid');
        const existing = input.parentNode.querySelector('.time-error-msg');
        if (existing) existing.remove();
    }

    function checkInputValidations() {
        let form = document.querySelector('#health-report-form');
        const currentTab = document.getElementById('v-health-reports-tab').querySelector('.active');
        const requiredInputs = form.querySelectorAll(
            'input[type="text"][required], input[type="time"][required], select[required]'
          ); // add other types when required

        for (const input of requiredInputs) {
            if (!input.value.trim()) {
                const tab = input.closest('[data-tab-id]');
                const tabId = tab?.dataset.tabId;

                if (tabId !== currentTab.id) {
                    document.getElementById(tabId).click();
                }

                input.focus();
                return false;
            }
        }
        return true;
    }

    function checkRadioGroup() {
        const radioBtnGroups = document.querySelectorAll('[id^="radio-group-"]');

        for(const radioBtnGroup of radioBtnGroups) {
            const hasCheckedRadio = radioBtnGroup.querySelector('input[type="radio"]:checked') !== null;
            if (!hasCheckedRadio) {
                const parentTabContent = radioBtnGroup.closest('[data-tab-id]');
                const parentTab = document.getElementById(parentTabContent.dataset.tabId);
                parentTab.click();
                radioBtnGroup.querySelector('input[type=radio]').focus();
                return false;
            }
        }
        return true;
    }

    function updateInspectionResponseValidations(targetTabId) {
        const healthReportTabs = document.getElementById('v-health-reports-tab').childNodes;
        healthReportTabs.forEach((tab) => {
            const tabDataSet = tab.dataset;
            if(tabDataSet.target !== targetTabId) {
                tab.classList.remove('active');
                document.getElementById(tabDataSet.tabContentId).classList.remove('show', 'active');
                inspectionResponseValidation(tabDataSet.tabContentId, false);
            }
            else {
                tab.classList.add('active');
                document.getElementById(tabDataSet.tabContentId).classList.add('show', 'active');
                inspectionResponseValidation(tabDataSet.tabContentId, true);
            }
        });
    }

    function updateTabValidations(targetId, tabToUpdate) {
        const tab = document.querySelector('div[data-target=signature]');
        const tabContent = document.getElementById(tab.dataset.tabContentId);
        const requiredFileds = tabContent.querySelectorAll('input[type=text].requiredField, input[type=time].requiredField');

        if(targetId === tabToUpdate) {
            requiredFileds.forEach(requiredFiled => {
                requiredFiled.setAttribute('required', true)
            })
        } else {
            requiredFileds.forEach(requiredFiled => {
                requiredFiled.removeAttribute('required')
            })
        }
    }
});
